import ky from 'ky';

import { AuthService } from '@/entities/auth/auth-service';

// Promise to track ongoing refresh attempts
let refreshPromise: Promise<void> | undefined = undefined;

export const paymentApiClient = ky.create({
  prefix: `${import.meta.env.VITE_PAYMENT_SERVER_URL}`,
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        // Refresh token if expired
        if (AuthService.isAccessTokenExpired() && !refreshPromise) {
          refreshPromise = AuthService.refreshToken()
            .catch(() => {
              // Ignore errors - afterResponse will handle 401
            })
            .finally(() => {
              refreshPromise = undefined;
            });
        }

        // Wait for any ongoing refresh
        if (refreshPromise) {
          try {
            await refreshPromise;
          } catch {
            // Continue with current token
          }
        }

        // Set authorization header
        const token = AuthService.getTokens()?.accessToken;
        if (token != null) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
  },
  retry: {
    limit: 2,
  },
  timeout: 60_000,
});
